import { render, staticRenderFns } from "./TabGlucoseChart.vue?vue&type=template&id=a1e2ba2e&scoped=true&"
import script from "./TabGlucoseChart.vue?vue&type=script&lang=js&"
export * from "./TabGlucoseChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e2ba2e",
  null
  
)

export default component.exports